import type {CourseApiModel} from '../../../api/course';

import {datetimeObjToISOString} from '../../datetime';

export const sortCoursesFn = (a: CourseApiModel, b: CourseApiModel) => {
  const defaultStartDate = '3000-01-01';

  return (
    Date.parse(datetimeObjToISOString(a.start_date) || defaultStartDate) -
    Date.parse(datetimeObjToISOString(b.start_date) || defaultStartDate)
  );
};
